import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { NavLinks, SidebarContainer, Link, LogoutDiv, Logout } from './Sidebar.styles';

import { ReactComponent as Logo } from '../../assets/icons/logo.svg';
import { logout } from '../../store/slices/auth/asyncThunks';
import { useDispatch } from 'react-redux';

const navLinks = [
  {
    label: 'dashboard',
    to: '/dashboard',
  },
  {
    label: 'logistics',
    to: '/logistics?page=1',
  },
  {
    label: 'partners',
    to: '/partners?page=1',
  },
  {
    label: 'products',
    to: '/products?page=1',
  },
  {
    label: 'orders',
    to: '/orders?page=1',
  },
  {
    label: 'inventory',
    to: '/inventory',
  },
];

const Sidebar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { t } = useTranslation();
  const { pathname } = useLocation();

  const handleLogout = () => {
    dispatch(logout());
  };

  return (
    <SidebarContainer>
      <Logo />
      <NavLinks>
        {navLinks.map(link => {
          return (
            <Link
              key={link.label}
              $active={
                pathname.includes('product-details') && link.label === 'products'
                  ? true
                  : pathname.includes('order-details') && link.label === 'orders'
                  ? true
                  : pathname.includes('delivery-details') && link.label === 'logistics'
                  ? true
                  : link.to.includes(pathname)
              }
              onClick={() => {
                navigate(link.to);
              }}>
              {t(link.label)}
            </Link>
          );
        })}
        <LogoutDiv onClick={handleLogout}>
          <Logout>{t('logout')}</Logout>
        </LogoutDiv>
      </NavLinks>
    </SidebarContainer>
  );
};

export default Sidebar;
